<template>
    <div class="admin-page">
        <!-- Main content -->
        <div class="main-cnt">
            <div class="content-white">
                <div class="content-body">
                    <div class="box-content">
                        <form class="form-group" @submit.prevent="setInfos">
                            <div class="d-flex mb-4">
                                <div class="pr-2 w-165">
                                    <button type="submit" class="btn btn-pink-53 w-100">
                                        {{ $t('button.ok') }}
                                    </button>
                                </div>
                            </div>

                            <div class="form-group-input-vc row-info form-input">
                                <label class="row-lb font500">
                                    {{ $t('company.general.full_name') }}
                                </label>
                                <div class="info-input-company">
                                    <select2
                                        id="searchCompanyId"
                                        v-model="companyId"
                                        class="" name="companyId"
                                        :options="companySelectOptions"
                                        :settings="companySelectSettings"
                                        v-validate.disable="'required'"
                                        @change="companySelectChangeEvent($event)"
                                        @select="companySelectEvent($event)">
                                    </select2>
                                </div>
                            </div>
                            <div class="form-group-input-vc row-info">
                                <label class="row-lb font500">
                                    {{$t('notify.title')}}
                                </label>
                                <div class="row-cnt">
                                    <div class="lst-type w-100">
                                    <ul class="row no-gutters">
                                        <li v-for="s in showInfos" :key="s.id" :value="s.id" class="col" @click="changeShowInfos(s.id)">
                                        <div class="type-txt" :class="{'active' : (selectedId == s.id) }" v-html="s.name"></div>
                                        </li>
                                    </ul>
                                    </div>
                                </div>
                            </div>
                            <div class="form-group-input-vc row-info">
                                <label class="row-lb font500">
                                    {{$t('notify.header')}}
                                </label>
                                <div class="row-cnt">
                                    <input
                                        v-model="infos.title"
                                        type="text"
                                        autocomplete="off"
                                        name="title"
                                        key="title"
                                        class="form-control"
                                        :data-vv-as="$t('notify.header')"
                                        v-validate.disable="'required|max:255'"
                                        :disabled="!isShowInfo">
                                    <div v-show="errors.has('title')" class="error-text">{{ errors.first('title') }}</div>
                                </div>
                            </div>
                            <div class="form-group-input-vc row-info">
                                <label class="row-lb font500">
                                    {{$t('notify.body')}}
                                </label>
                                <div class="row-cnt">
                                    <textarea
                                    v-model="infos.body"
                                    name="body"
                                    class="form-control"
                                    :data-vv-as="$t('notify.body')"
                                    v-validate.disable="'required|max:255'"
                                    style="height: 10rem;"
                                    :disabled="!isShowInfo">
                                    </textarea>
                                    <div v-show="errors.has('body')" class="error-text">{{ errors.first('body') }}</div>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Utils from '@/helpers/utils';

import InfoService from '@/services/admin/infos.service';
import {AuthService} from '@/services/common/auth.service';
import StorageService from '@/services/common/storage.service';
import GroupManagementService from '@/services/admin/group.service';

export default {
    data () {
        return {
            showInfos: [
                {
                    id: 1,
                    name: "あり",
                },
                {
                    id: 2,
                    name: "なし",
                }
            ],
            isShowInfo: false,
            selectedId: 1,
            infos : {},
            companyId: 1,
            companySelectOptions: [],
            companySelectSettings: {
                allowClear: true,
                multiple: false,
                width: '100%',
                theme: 'bootstrap',
                placeholder: this.$t('place_holder.company'),
                data: this.companySelectOptions,
            },
        };
    },
    mounted () {
        InfoService.getInfo().then(response =>{
            if (response.status == 423) {
                StorageService.saveExpired();
                AuthService.doLogout();
            }
            if (response.status == 200) {
                this.infos = response.data;
                if(this.infos) {
                    this.selectedId = this.infos.is_notify ? 1 : 2;
                    this.isShowInfo = this.infos.is_notify;
                    this.getAllCompanies();
                }
            }
        })

    },
    methods: {
        changeShowInfos (id) {
            this.selectedId = id;
            this.isShowInfo = id == this.showInfos[0].id;
        },
        setInfos (e) {
            if (Utils.isEmptyStr(this.infos.title) || Utils.isEmptyStr(this.infos.body)) {
                let msg = this.$root.$t("error.error_notify_empty");
                this.$toasted.error(msg, {});

                return;
            }
            let params = {
                id: this.infos.id,
                title: this.infos.title,
                body: this.infos.body,
                is_notify: this.isShowInfo,
            }

            InfoService.setInfo(params).then(response =>{
                if (response.status == 423) {
                    StorageService.saveExpired();
                    AuthService.doLogout();
                }
                if (response.status == 200) {
                    let msg = this.$root.$t("success.update_success");
                    this.$toasted.success(msg, {});
                } else {
                    let msg = this.$root.$t("error.error_validate");
                    this.$toasted.error(msg, {});
                }
            })
        },

        getAllCompanies: function getAllCompanies () {
            GroupManagementService.getAllCompanies()
                .then(response => {
                    if (response.status == 423) {
                        StorageService.saveExpired();
                        AuthService.doLogout();
                    }
                    if (response.status == 200 && response.data) {
                        let _dataSelect = [];
                        $.each(response.data, function (key, value) {
                            if (!Utils.isEmptyStr(value.id) && Utils.isEmptyStr(value.name)) {
                                return true;
                            }

                            let item = {
                                id: value.id,
                                text: value.name,
                            };
                            _dataSelect.push(item);
                        });

                        this.companySelectOptions = _dataSelect;
                    } else {
                        this.companySelectOptions = [];
                    }
                }).catch(error => {
                    this.companySelectOptions = [];
                });
            return false;
        },

        companySelectChangeEvent (val) {
            InfoService.getInfo({ company_id: this.companyId }).then(response =>{
                if (response.status == 423) {
                    StorageService.saveExpired();
                    AuthService.doLogout();
                }
                if (response.status == 200) {
                    this.infos = response.data || {};
                    if(this.infos) {
                        this.selectedId = this.infos.is_notify ? 1 : 2;
                        this.isShowInfo = this.infos.is_notify;
                    }
                }
            }).catch (err => {
                this.isShowInfo = false;
                this.selectedId = 1;
                this.infos = {};
                let msg = this.$root.$t("error.error_info_list");
                this.$toasted.error(msg, {});
            });
        },

        companySelectEvent ({id, text}) {
        },
    }
}

</script>



// WEBPACK FOOTER //
// src/views/components/admin/InfoManagement/List.vue